const catalogCardMessages = ["'lot-loaded'", "'auction-opened'", "'auction-closed'"];

const catalogPageMessages = [
    "'ask-changed'",
    "'auction-closed'",
    "'auction-opened'",
    "'bid-accepted'",
    "'bid-placed'",
    "'bid-retracted'",
    "'bidder-retraction'",
    "'lot-closed'",
    "'lot-loaded'",
    "'lot-passed'",
    "'lot-reopened'",
    "'lot-skipped'",
    "'lot-sold'",
    "'lot-unsold'",
];

const itemCardMessages = [
    "'ask-changed'",
    "'bid-accepted'",
    "'bid-placed'",
    "'bid-retracted'",
    "'bidder-retraction'",
    "'lot-closed'",
    "'lot-loaded'",
    "'lot-passed'",
    "'lot-reopened'",
    "'lot-skipped'",
    "'lot-sold'",
    "'lot-unsold'",
];

const itemCarouselMessages = ["'lot-loaded'"];

export type FilterOptions = 'catalogCard' | 'catalogPageConsole' | 'itemCard' | 'itemCardCarousel';

export const pubnubFilters = {
    catalogCard: `(((${catalogCardMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
    catalogPageConsole: `(((${catalogPageMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
    itemCard: `(((${itemCardMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
    itemCardCarousel: `(((${itemCarouselMessages.join(', ')}) contains EventType) || isPresenceEvent)`,
};
